import { ApiRoutes } from '@utils/api-routes'
import http from '@utils/http'

export const DEFAULT_DIFFICULTY = 'medium'
export const DEFAULT_SCORE = 80
export const DEFAULT_ATTEMPTS = 'Unlimited'

interface CreateProps {
  exerciseId: string
  difficulty: string
  minimumScore: number
  maxAttempts: number | string | null
}
export async function createAssignment({
  exerciseId,
  difficulty = DEFAULT_DIFFICULTY,
  minimumScore = DEFAULT_SCORE,
  maxAttempts = DEFAULT_ATTEMPTS,
}: CreateProps): Promise<string | undefined> {
  const [resp, err] = await http.post(ApiRoutes.apiCreateSoundCheckAssignment(), {
    exercise_id: exerciseId,
    difficulty_level: difficulty,
    minimum_rating: minimumScore,
    maximum_attempts: maxAttempts == 'Unlimited' ? null : maxAttempts,
  })
  if (resp) {
    return resp.data.assignment_id
  } else if (err) {
    throw err
  }
}
